function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconTrafficSignGiveWayEu(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Give_x5F_Way_x5F_EU",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "96px",
    height: "96px",
    viewBox: "0 0 96 96",
    style: {
      enableBackground: "new 0 0 96 96"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M6.002,8h83.995c3.084,0,5.006,3.346,3.452,6.011L51.452,86.017c-1.542,2.644-5.362,2.644-6.904,0 L2.55,14.011C0.996,11.346,2.918,8,6.002,8z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M89.998,8H6.002c-3.084,0-5.006,3.346-3.452,6.011l41.998,72.006C45.319,87.339,46.66,88,48,88 s2.681-0.661,3.452-1.983L93.45,14.011C95.004,11.346,93.082,8,89.998,8L89.998,8z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#B33229"
    },
    d: "M79.573,18L48,72.132L16.427,18H79.573 M90.018,10H5.982c-1.544,0-2.505,1.674-1.728,3.008 l42.018,72.041c0.386,0.662,1.057,0.992,1.728,0.992s1.342-0.331,1.728-0.992l42.018-72.041C92.523,11.674,91.562,10,90.018,10 L90.018,10z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconTrafficSignGiveWayEu);
export default __webpack_public_path__ + "static/media/icon-traffic_sign_give_way_eu.72c4f4c909a2ea5215632ee14fbc9e0b.svg";
export { ForwardRef as ReactComponent };